module.exports = __webpack_public_path__ + "static/8-1b0b39f800d8f6ee61099f05b48da573.jpeg";